import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import OwlCarousel from "react-owl-carousel";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function InfoDuoBoxFacilities() {
  const [facilitiesData, setFacilitiesData] = useState([]);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setFacilitiesData(response?.data);
  };

  const options = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  };

  return (
    <>
      {facilitiesData?.length > 0 ? (
        <section id="feature-section" className="feature-section pb-4 pt-5">
          <div className="container">
            <div className="row mb-4">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-40">
                    <h2 className="title mb-0 text-uppercase">
                      Our <span className="theme-color">Facilities</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row" data-animation="fadeInDown">
              {facilitiesData?.length === 0 ? (
                <div
                  style={{ marginBottom: "100px" }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <Spinner />
                </div>
              ) : (
                <OwlCarousel className="service-main-wrapper" {...options}>
                  {facilitiesData?.map((data, index) => (
                    <div key={index} className="item animated fadeInLeft visible">
                      <div className="feature-box-wrap f-box-style-6 relative duo-box-home-height">
                        <div className="feature-box-details h-100">
                          <div className="feature-img">
                            <img
                              className="img-fluid"
                              src={data?.facility_image}
                              style={{ height: "auto" }}
                              alt="feature img"
                            />
                          </div>
                          <div className="feature-content mt-4 mb-3">
                            <div className="feature-title relative margin-bottom-5">
                              <h5>
                                {" "}
                                <Link
                                  to={`/facility/${data?.facility_slug
                                    ?.replaceAll(" ", "-")
                                    ?.replaceAll("/", "-")}`}
                                >
                                  {data?.facility_title}
                                </Link>
                              </h5>
                            </div>
                            <p
                              className="mb-0 facilities-listing-1"
                              dangerouslySetInnerHTML={{
                                __html:
                                  limitParagraphByCharLimit(data?.facility_short_description, 70) +
                                  (data?.facility_short_description?.length > 70 ? "..." : ""),
                              }}
                            />
                          </div>
                          <div className="button">
                            <Link
                              className="btn-link"
                              to={`/facility/${data?.facility_slug
                                ?.replaceAll(" ", "-")
                                ?.replaceAll("/", "-")}`}
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              )}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default InfoDuoBoxFacilities;
